import Vue from 'vue'
import Api from './api'
import * as util from './util'
import {
  getBrower,
  getENV,
  isAndroidBrower,
  isBrower,
  isDocClient,
  isIphoneBrower,
  isPatClient,
  isDevelopment, envIsTest, envIsDev, isAlipayMini, isWeixin
} from './util'
import weuijs from 'weui.js'
import storage from 'good-storage'

import AppHeader from '../plugins/app-header'
import Msg from '../plugins/msg'
import {BG_COLOR, DOWNLOAD, DOWNLOAD_CONTENT, ICONS, MAIN_COLOR} from "./config";
import {
  VERSION5_3_0,
  VERSION5_3_1,
  VERSION5_5_0,
  VERSION5_5_1,
  VERSION5_6_0,
  VERSION5_8_0,
  VERSION6_5_1
} from "@/lib/version";
import {appidConfigCache} from "@/lib/cache";
import {monitor} from "@/lib/monitor";


export default {
  install() {
    /*添加实例方法*/
    Vue.prototype.$http = Api;
    Vue.prototype.$util = util;
    Vue.prototype.$weuijs = weuijs;
    Vue.prototype.$cache = storage.session;
    Vue.prototype.$storage = storage;
    Vue.prototype.$brower = getBrower();
    Vue.prototype.$icons = ICONS;


    /*添加全局mixin*/
    Vue.mixin({
      data() {
        return {
          env: getENV(),
          get: url("?") || {},
          is5_3_0: VERSION5_3_0,
          is5_3_1: VERSION5_3_1,
          is5_5_0: VERSION5_5_0,
          is5_5_1: VERSION5_5_1,
          is5_6_0: VERSION5_6_0,
          is5_8_0: VERSION5_8_0,
          is6_5_1: VERSION6_5_1,
          mainColor: MAIN_COLOR,
          bgColor: BG_COLOR,
          appid: '',
          weuijsDialog: null,
          isMobile: isIphoneBrower() || isAndroidBrower(),
          isAndroidBrower: isAndroidBrower(),
          isIphoneBrower: isIphoneBrower(),
          isDocClient: isDocClient(),
          isPatClient: isPatClient(),
          isDevelopment: isDevelopment(),
          isAlipayMini: isAlipayMini(),
          defaultThumb: require('../assets/default-thumb@3x.png')
        }
      },
      computed: {
        isDev() {
          return this.env.plat === 'dev';
        },
        isTest() {
          return this.env.plat === 'test';
        },
        isPro() {
          return this.env.plat === 'pro';
        },
        isAlipay() {
          return this.$brower === 'alipay';
        },
        isWeixin() {
          return this.$brower === 'weixin';
        },
        requestLoading() {
          return this.$store.state.requestLoading;
        },
        inDocClient() {
          return this.get.client === 'doc' || this.isDocClient;
        },
        inPatClient() {
          return this.get.client === 'pat' || this.isPatClient;
        },

        appLogo() {
          const {channel} = this.get;
          if (channel == 11) return require('@/../static/img/channel.11.png');
          if (channel == 10) return require('@/../static/img/channel.10.png');
          return require('@/../static/img/channel.3.png');
        }
      },
      components: {AppHeader, Msg},
      created() {
        let cache = appidConfigCache.get() || {};
        let vm = window.vm || {};
        this.appid = vm.appid || cache.appid;
        //Log('timestemp', Date.now());
      },

      beforeDestroy() {
      },
      methods: {
        /**
         * vant 验证手机号
         * @param value
         * @returns {boolean}
         */
        validatorMobile(value) {
          return /^1\d{10}$/.test(value);
        },

        // 常用跳转链接
        /**
         * 医生名片
         * @param docId
         * @param ext
         */
        gotoDocCard(docId, ext = {}) {
          Log('docId', docId);
          this.$router.push({
            path: '/doc/index',
            query: {docId, ...ext}
          })
        },

        /**
         * 团队名片
         * @param teamId
         * @param ext
         */
        gotoTeamCard(teamId, ext = {}) {
          if (isDevelopment() || isWeixin())
            this.$router.push({
              path: '/team/' + teamId + '/detail',
              query: {
                ...ext
              }
            })
          else this.doNativeAction('tynet://smarthos.team.info.card?id=' + teamId);
        },

        gotoNewsDetail(data, type) {
          if (data.newsType === 'EXTERNALLINKS') {
            location.href = data.content;
          } else {
            this.$router.push({
              path: `/news/detail/${data.newId}`
            })
          }
        },

        wktSzyx() {
          this.$weuijs.alert('您院内就诊时未选择该服务，暂不可用；在线办理功能即将上线，敬请期待。', {
            isAndroid: false,
            buttons: [{
              label: '我知道了',
              type: 'primary',
              onClick: () => {
              }
            }]
          });
        },
        modalAliapy() {
          this.$weuijs.alert(`正在建设中`, {
            title: '提示',
            isAndroid: false
          })
        },
        downloadAPP(no, yes) {
          this.$weuijs.confirm(`${DOWNLOAD_CONTENT}继续使用`, {
            title: '提示',
            isAndroid: false,
            buttons: [
              {
                label: '取消',
                type: 'default',
                onClick: () => {
                  no && no();
                }
              },
              {
                label: '下载APP',
                type: 'primary',
                onClick: () => {
                  location.href = DOWNLOAD
                }
              }
            ]
          })
        },
        async getSystemString(data) {
          const {code, obj} = await this.$http('nethos.system.param.string', {
            key: data,
            defaultString: data
          })
          if (code === '0') return obj;
          else return null;
        },
        doNativeAction(url) {
          Log('scheme', url);
          monitor.api('open.app.by.scheme', true, 1, 0, url);
          if (isDevelopment() || envIsTest() || envIsDev()) bus.$emit('msg', '即将打开APP ' + url);
          if (isBrower('iphone')) {
            location.href = url;
          } else if (isBrower('android')) {
            const iframe = document.createElement('iframe');
            iframe.style.width = '1px';
            iframe.style.height = '1px';
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
            setTimeout(function () {
              iframe.remove();
            }, 100);
          }
        },
        nativeBack() {
          if (isIphoneBrower() || isAndroidBrower()) {
            const schema = 'tynet://smarthos.native.back';
            Log('schema', schema);
            this.doNativeAction(schema);
          } else {
            this.$router.go(-1);
          }
        },
        nativeLogin() {
          if (isIphoneBrower() || isAndroidBrower()) {
            const schema = 'tynet://smarthos.native.login';
            Log('schema', schema);
            this.doNativeAction(schema);
          }
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/install.js